<script setup lang="ts">
import { AccordionContent, type AccordionContentProps } from 'reka-ui'
import { cn } from '@/lib/utils'
import type { HTMLAttributes } from 'vue'

const props = defineProps<AccordionContentProps & { class?: HTMLAttributes['class'] }>()
</script>

<template>
    <AccordionContent
        v-bind="{ ...props, class: undefined }"
        :class="
            cn(
                'text-sm bg-background data-[state=closed]:overflow-hidden data-[state=open]:overflow-visible data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down',
                props.class,
            )
        "
    >
        <div class="pb-4 pt-0">
            <slot />
        </div>
    </AccordionContent>
</template>
